const data = [
    {
        "name": "北京",
        "adcode": "110100",
        "citycode": "010"
    },
    {
        "name": "天津",
        "adcode": "120100",
        "citycode": "022"
    },
    {
        "name": "石家庄",
        "adcode": "130100",
        "citycode": "0311"
    },
    {
        "name": "唐山",
        "adcode": "130200",
        "citycode": "0315"
    },
    {
        "name": "秦皇岛",
        "adcode": "130300",
        "citycode": "0335"
    },
    {
        "name": "邯郸",
        "adcode": "130400",
        "citycode": "0310"
    },
    {
        "name": "邢台",
        "adcode": "130500",
        "citycode": "0319"
    },
    {
        "name": "保定",
        "adcode": "130600",
        "citycode": "0312"
    },
    {
        "name": "张家口",
        "adcode": "130700",
        "citycode": "0313"
    },
    {
        "name": "承德",
        "adcode": "130800",
        "citycode": "0314"
    },
    {
        "name": "沧州",
        "adcode": "130900",
        "citycode": "0317"
    },
    {
        "name": "廊坊",
        "adcode": "131000",
        "citycode": "0316"
    },
    {
        "name": "衡水",
        "adcode": "131100",
        "citycode": "0318"
    },
    {
        "name": "太原",
        "adcode": "140100",
        "citycode": "0351"
    },
    {
        "name": "大同",
        "adcode": "140200",
        "citycode": "0352"
    },
    {
        "name": "阳泉",
        "adcode": "140300",
        "citycode": "0353"
    },
    {
        "name": "长治",
        "adcode": "140400",
        "citycode": "0355"
    },
    {
        "name": "晋城",
        "adcode": "140500",
        "citycode": "0356"
    },
    {
        "name": "朔州",
        "adcode": "140600",
        "citycode": "0349"
    },
    {
        "name": "晋中",
        "adcode": "140700",
        "citycode": "0354"
    },
    {
        "name": "运城",
        "adcode": "140800",
        "citycode": "0359"
    },
    {
        "name": "忻州",
        "adcode": "140900",
        "citycode": "0350"
    },
    {
        "name": "临汾",
        "adcode": "141000",
        "citycode": "0357"
    },
    {
        "name": "吕梁",
        "adcode": "141100",
        "citycode": "0358"
    },
    {
        "name": "呼和浩特",
        "adcode": "150100",
        "citycode": "0471"
    },
    {
        "name": "包头",
        "adcode": "150200",
        "citycode": "0472"
    },
    {
        "name": "乌海",
        "adcode": "150300",
        "citycode": "0473"
    },
    {
        "name": "赤峰",
        "adcode": "150400",
        "citycode": "0476"
    },
    {
        "name": "通辽",
        "adcode": "150500",
        "citycode": "0475"
    },
    {
        "name": "呼伦贝尔",
        "adcode": "150700",
        "citycode": "0470"
    },
    {
        "name": "沈阳",
        "adcode": "210100",
        "citycode": "024"
    },
    {
        "name": "大连",
        "adcode": "210200",
        "citycode": "0411"
    },
    {
        "name": "鞍山",
        "adcode": "210300",
        "citycode": "0412"
    },
    {
        "name": "抚顺",
        "adcode": "210400",
        "citycode": "0413"
    },
    {
        "name": "本溪",
        "adcode": "210500",
        "citycode": "0414"
    },
    {
        "name": "丹东",
        "adcode": "210600",
        "citycode": "0415"
    },
    {
        "name": "锦州",
        "adcode": "210700",
        "citycode": "0416"
    },
    {
        "name": "营口",
        "adcode": "210800",
        "citycode": "0417"
    },
    {
        "name": "阜新",
        "adcode": "210900",
        "citycode": "0418"
    },
    {
        "name": "辽阳",
        "adcode": "211000",
        "citycode": "0419"
    },
    {
        "name": "盘锦",
        "adcode": "211100",
        "citycode": "0427"
    },
    {
        "name": "铁岭",
        "adcode": "211200",
        "citycode": "0410"
    },
    {
        "name": "朝阳",
        "adcode": "211300",
        "citycode": "0421"
    },
    {
        "name": "葫芦岛",
        "adcode": "211400",
        "citycode": "0429"
    },
    {
        "name": "长春",
        "adcode": "220100",
        "citycode": "0431"
    },
    {
        "name": "吉林",
        "adcode": "220200",
        "citycode": "0432"
    },
    {
        "name": "四平",
        "adcode": "220300",
        "citycode": "0434"
    },
    {
        "name": "辽源",
        "adcode": "220400",
        "citycode": "0437"
    },
    {
        "name": "通化",
        "adcode": "220500",
        "citycode": "0435"
    },
    {
        "name": "白山",
        "adcode": "220600",
        "citycode": "0439"
    },
    {
        "name": "松原",
        "adcode": "220700",
        "citycode": "0438"
    },
    {
        "name": "白城",
        "adcode": "220800",
        "citycode": "0436"
    },
    {
        "name": "哈尔滨",
        "adcode": "230100",
        "citycode": "0451"
    },
    {
        "name": "齐齐哈尔",
        "adcode": "230200",
        "citycode": "0452"
    },
    {
        "name": "鸡西",
        "adcode": "230300",
        "citycode": "0467"
    },
    {
        "name": "鹤岗",
        "adcode": "230400",
        "citycode": "0468"
    },
    {
        "name": "大庆",
        "adcode": "230600",
        "citycode": "0459"
    },
    {
        "name": "伊春",
        "adcode": "230700",
        "citycode": "0458"
    },
    {
        "name": "佳木斯",
        "adcode": "230800",
        "citycode": "0454"
    },
    {
        "name": "七台河",
        "adcode": "230900",
        "citycode": "0464"
    },
    {
        "name": "牡丹江",
        "adcode": "231000",
        "citycode": "0453"
    },
    {
        "name": "黑河",
        "adcode": "231100",
        "citycode": "0456"
    },
    {
        "name": "绥化",
        "adcode": "231200",
        "citycode": "0455"
    },
    {
        "name": "上海",
        "adcode": "310100",
        "citycode": "021"
    },
    {
        "name": "南京",
        "adcode": "320100",
        "citycode": "025"
    },
    {
        "name": "无锡",
        "adcode": "320200",
        "citycode": "0510"
    },
    {
        "name": "徐州",
        "adcode": "320300",
        "citycode": "0516"
    },
    {
        "name": "常州",
        "adcode": "320400",
        "citycode": "0519"
    },
    {
        "name": "苏州",
        "adcode": "320500",
        "citycode": "0512"
    },
    {
        "name": "南通",
        "adcode": "320600",
        "citycode": "0513"
    },
    {
        "name": "连云港",
        "adcode": "320700",
        "citycode": "0518"
    },
    {
        "name": "淮安",
        "adcode": "320800",
        "citycode": "0517"
    },
    {
        "name": "盐城",
        "adcode": "320900",
        "citycode": "0515"
    },
    {
        "name": "扬州",
        "adcode": "321000",
        "citycode": "0514"
    },
    {
        "name": "镇江",
        "adcode": "321100",
        "citycode": "0511"
    },
    {
        "name": "泰州",
        "adcode": "321200",
        "citycode": "0523"
    },
    {
        "name": "宿迁",
        "adcode": "321300",
        "citycode": "0527"
    },
    {
        "name": "杭州",
        "adcode": "330100",
        "citycode": "0571"
    },
    {
        "name": "宁波",
        "adcode": "330200",
        "citycode": "0574"
    },
    {
        "name": "温州",
        "adcode": "330300",
        "citycode": "0577"
    },
    {
        "name": "嘉兴",
        "adcode": "330400",
        "citycode": "0573"
    },
    {
        "name": "湖州",
        "adcode": "330500",
        "citycode": "0572"
    },
    {
        "name": "绍兴",
        "adcode": "330600",
        "citycode": "0575"
    },
    {
        "name": "金华",
        "adcode": "330700",
        "citycode": "0579"
    },
    {
        "name": "衢州",
        "adcode": "330800",
        "citycode": "0570"
    },
    {
        "name": "舟山",
        "adcode": "330900",
        "citycode": "0580"
    },
    {
        "name": "台州",
        "adcode": "331000",
        "citycode": "0576"
    },
    {
        "name": "丽水",
        "adcode": "331100",
        "citycode": "0578"
    },
    {
        "name": "合肥",
        "adcode": "340100",
        "citycode": "0551"
    },
    {
        "name": "芜湖",
        "adcode": "340200",
        "citycode": "0553"
    },
    {
        "name": "蚌埠",
        "adcode": "340300",
        "citycode": "0552"
    },
    {
        "name": "淮南",
        "adcode": "340400",
        "citycode": "0554"
    },
    {
        "name": "马鞍山",
        "adcode": "340500",
        "citycode": "0555"
    },
    {
        "name": "淮北",
        "adcode": "340600",
        "citycode": "0561"
    },
    {
        "name": "铜陵",
        "adcode": "340700",
        "citycode": "0562"
    },
    {
        "name": "安庆",
        "adcode": "340800",
        "citycode": "0556"
    },
    {
        "name": "黄山",
        "adcode": "341000",
        "citycode": "0559"
    },
    {
        "name": "滁州",
        "adcode": "341100",
        "citycode": "0550"
    },
    {
        "name": "阜阳",
        "adcode": "341200",
        "citycode": "1558"
    },
    {
        "name": "宿州",
        "adcode": "341300",
        "citycode": "0557"
    },
    {
        "name": "六安",
        "adcode": "341500",
        "citycode": "0564"
    },
    {
        "name": "亳州",
        "adcode": "341600",
        "citycode": "0558"
    },
    {
        "name": "池州",
        "adcode": "341700",
        "citycode": "0566"
    },
    {
        "name": "宣城",
        "adcode": "341800",
        "citycode": "0563"
    },
    {
        "name": "福州",
        "adcode": "350100",
        "citycode": "0591"
    },
    {
        "name": "厦门",
        "adcode": "350200",
        "citycode": "0592"
    },
    {
        "name": "莆田",
        "adcode": "350300",
        "citycode": "0594"
    },
    {
        "name": "三明",
        "adcode": "350400",
        "citycode": "0598"
    },
    {
        "name": "泉州",
        "adcode": "350500",
        "citycode": "0595"
    },
    {
        "name": "漳州",
        "adcode": "350600",
        "citycode": "0596"
    },
    {
        "name": "南平",
        "adcode": "350700",
        "citycode": "0599"
    },
    {
        "name": "龙岩",
        "adcode": "350800",
        "citycode": "0597"
    },
    {
        "name": "宁德",
        "adcode": "350900",
        "citycode": "0593"
    },
    {
        "name": "南昌",
        "adcode": "360100",
        "citycode": "0791"
    },
    {
        "name": "景德镇",
        "adcode": "360200",
        "citycode": "0798"
    },
    {
        "name": "萍乡",
        "adcode": "360300",
        "citycode": "0799"
    },
    {
        "name": "九江",
        "adcode": "360400",
        "citycode": "0792"
    },
    {
        "name": "新余",
        "adcode": "360500",
        "citycode": "0790"
    },
    {
        "name": "鹰潭",
        "adcode": "360600",
        "citycode": "0701"
    },
    {
        "name": "赣州",
        "adcode": "360700",
        "citycode": "0797"
    },
    {
        "name": "吉安",
        "adcode": "360800",
        "citycode": "0796"
    },
    {
        "name": "宜春",
        "adcode": "360900",
        "citycode": "0795"
    },
    {
        "name": "抚州",
        "adcode": "361000",
        "citycode": "0794"
    },
    {
        "name": "上饶",
        "adcode": "361100",
        "citycode": "0793"
    },
    {
        "name": "济南",
        "adcode": "370100",
        "citycode": "0531"
    },
    {
        "name": "青岛",
        "adcode": "370200",
        "citycode": "0532"
    },
    {
        "name": "淄博",
        "adcode": "370300",
        "citycode": "0533"
    },
    {
        "name": "枣庄",
        "adcode": "370400",
        "citycode": "0632"
    },
    {
        "name": "东营",
        "adcode": "370500",
        "citycode": "0546"
    },
    {
        "name": "烟台",
        "adcode": "370600",
        "citycode": "0535"
    },
    {
        "name": "潍坊",
        "adcode": "370700",
        "citycode": "0536"
    },
    {
        "name": "济宁",
        "adcode": "370800",
        "citycode": "0537"
    },
    {
        "name": "泰安",
        "adcode": "370900",
        "citycode": "0538"
    },
    {
        "name": "威海",
        "adcode": "371000",
        "citycode": "0631"
    },
    {
        "name": "日照",
        "adcode": "371100",
        "citycode": "0633"
    },
    {
        "name": "临沂",
        "adcode": "371300",
        "citycode": "0539"
    },
    {
        "name": "德州",
        "adcode": "371400",
        "citycode": "0534"
    },
    {
        "name": "聊城",
        "adcode": "371500",
        "citycode": "0635"
    },
    {
        "name": "滨州",
        "adcode": "371600",
        "citycode": "0543"
    },
    {
        "name": "菏泽",
        "adcode": "371700",
        "citycode": "0530"
    },
    {
        "name": "郑州",
        "adcode": "410100",
        "citycode": "0371"
    },
    {
        "name": "开封",
        "adcode": "410200",
        "citycode": "0378"
    },
    {
        "name": "洛阳",
        "adcode": "410300",
        "citycode": "0379"
    },
    {
        "name": "平顶山",
        "adcode": "410400",
        "citycode": "0375"
    },
    {
        "name": "安阳",
        "adcode": "410500",
        "citycode": "0372"
    },
    {
        "name": "鹤壁",
        "adcode": "410600",
        "citycode": "0392"
    },
    {
        "name": "新乡",
        "adcode": "410700",
        "citycode": "0373"
    },
    {
        "name": "焦作",
        "adcode": "410800",
        "citycode": "0391"
    },
    {
        "name": "濮阳",
        "adcode": "410900",
        "citycode": "0393"
    },
    {
        "name": "许昌",
        "adcode": "411000",
        "citycode": "0374"
    },
    {
        "name": "漯河",
        "adcode": "411100",
        "citycode": "0395"
    },
    {
        "name": "三门峡",
        "adcode": "411200",
        "citycode": "0398"
    },
    {
        "name": "南阳",
        "adcode": "411300",
        "citycode": "0377"
    },
    {
        "name": "商丘",
        "adcode": "411400",
        "citycode": "0370"
    },
    {
        "name": "信阳",
        "adcode": "411500",
        "citycode": "0376"
    },
    {
        "name": "周口",
        "adcode": "411600",
        "citycode": "0394"
    },
    {
        "name": "驻马店",
        "adcode": "411700",
        "citycode": "0396"
    },
    {
        "name": "武汉",
        "adcode": "420100",
        "citycode": "027"
    },
    {
        "name": "黄石",
        "adcode": "420200",
        "citycode": "0714"
    },
    {
        "name": "十堰",
        "adcode": "420300",
        "citycode": "0719"
    },
    {
        "name": "宜昌",
        "adcode": "420500",
        "citycode": "0717"
    },
    {
        "name": "襄阳",
        "adcode": "420600",
        "citycode": "0710"
    },
    {
        "name": "鄂州",
        "adcode": "420700",
        "citycode": "0711"
    },
    {
        "name": "荆门",
        "adcode": "420800",
        "citycode": "0724"
    },
    {
        "name": "孝感",
        "adcode": "420900",
        "citycode": "0712"
    },
    {
        "name": "荆州",
        "adcode": "421000",
        "citycode": "0716"
    },
    {
        "name": "黄冈",
        "adcode": "421100",
        "citycode": "0713"
    },
    {
        "name": "咸宁",
        "adcode": "421200",
        "citycode": "0715"
    },
    {
        "name": "随州",
        "adcode": "421300",
        "citycode": "0722"
    },
    {
        "name": "长沙",
        "adcode": "430100",
        "citycode": "0731"
    },
    {
        "name": "株洲",
        "adcode": "430200",
        "citycode": "0733"
    },
    {
        "name": "湘潭",
        "adcode": "430300",
        "citycode": "0732"
    },
    {
        "name": "衡阳",
        "adcode": "430400",
        "citycode": "0734"
    },
    {
        "name": "邵阳",
        "adcode": "430500",
        "citycode": "0739"
    },
    {
        "name": "岳阳",
        "adcode": "430600",
        "citycode": "0730"
    },
    {
        "name": "常德",
        "adcode": "430700",
        "citycode": "0736"
    },
    {
        "name": "张家界",
        "adcode": "430800",
        "citycode": "0744"
    },
    {
        "name": "益阳",
        "adcode": "430900",
        "citycode": "0737"
    },
    {
        "name": "郴州",
        "adcode": "431000",
        "citycode": "0735"
    },
    {
        "name": "永州",
        "adcode": "431100",
        "citycode": "0746"
    },
    {
        "name": "怀化",
        "adcode": "431200",
        "citycode": "0745"
    },
    {
        "name": "娄底",
        "adcode": "431300",
        "citycode": "0738"
    },
    {
        "name": "广州",
        "adcode": "440100",
        "citycode": "020"
    },
    {
        "name": "韶关",
        "adcode": "440200",
        "citycode": "0751"
    },
    {
        "name": "深圳",
        "adcode": "440300",
        "citycode": "0755"
    },
    {
        "name": "珠海",
        "adcode": "440400",
        "citycode": "0756"
    },
    {
        "name": "汕头",
        "adcode": "440500",
        "citycode": "0754"
    },
    {
        "name": "佛山",
        "adcode": "440600",
        "citycode": "0757"
    },
    {
        "name": "江门",
        "adcode": "440700",
        "citycode": "0750"
    },
    {
        "name": "湛江",
        "adcode": "440800",
        "citycode": "0759"
    },
    {
        "name": "茂名",
        "adcode": "440900",
        "citycode": "0668"
    },
    {
        "name": "肇庆",
        "adcode": "441200",
        "citycode": "0758"
    },
    {
        "name": "惠州",
        "adcode": "441300",
        "citycode": "0752"
    },
    {
        "name": "梅州",
        "adcode": "441400",
        "citycode": "0753"
    },
    {
        "name": "汕尾",
        "adcode": "441500",
        "citycode": "0660"
    },
    {
        "name": "河源",
        "adcode": "441600",
        "citycode": "0762"
    },
    {
        "name": "阳江",
        "adcode": "441700",
        "citycode": "0662"
    },
    {
        "name": "清远",
        "adcode": "441800",
        "citycode": "0763"
    },
    {
        "name": "东莞",
        "adcode": "441900",
        "citycode": "0769"
    },
    {
        "name": "中山",
        "adcode": "442000",
        "citycode": "0760"
    },
    {
        "name": "潮州",
        "adcode": "445100",
        "citycode": "0768"
    },
    {
        "name": "揭阳",
        "adcode": "445200",
        "citycode": "0663"
    },
    {
        "name": "云浮",
        "adcode": "445300",
        "citycode": "0766"
    },
    {
        "name": "南宁",
        "adcode": "450100",
        "citycode": "0771"
    },
    {
        "name": "柳州",
        "adcode": "450200",
        "citycode": "0772"
    },
    {
        "name": "桂林",
        "adcode": "450300",
        "citycode": "0773"
    },
    {
        "name": "梧州",
        "adcode": "450400",
        "citycode": "0774"
    },
    {
        "name": "北海",
        "adcode": "450500",
        "citycode": "0779"
    },
    {
        "name": "防城港",
        "adcode": "450600",
        "citycode": "0770"
    },
    {
        "name": "钦州",
        "adcode": "450700",
        "citycode": "0777"
    },
    {
        "name": "贵港",
        "adcode": "450800",
        "citycode": "1755"
    },
    {
        "name": "玉林",
        "adcode": "450900",
        "citycode": "0775"
    },
    {
        "name": "百色",
        "adcode": "451000",
        "citycode": "0776"
    },
    {
        "name": "贺州",
        "adcode": "451100",
        "citycode": "1774"
    },
    {
        "name": "河池",
        "adcode": "451200",
        "citycode": "0778"
    },
    {
        "name": "来宾",
        "adcode": "451300",
        "citycode": "1772"
    },
    {
        "name": "崇左",
        "adcode": "451400",
        "citycode": "1771"
    },
    {
        "name": "海口",
        "adcode": "460100",
        "citycode": "0898"
    },
    {
        "name": "三亚",
        "adcode": "460200",
        "citycode": "0899"
    },
    {
        "name": "三沙",
        "adcode": "460300",
        "citycode": "2898"
    },
    {
        "name": "儋州",
        "adcode": "460400",
        "citycode": "0805"
    },
    {
        "name": "重庆",
        "adcode": "500100",
        "citycode": "023"
    },
    {
        "name": "成都",
        "adcode": "510100",
        "citycode": "028"
    },
    {
        "name": "自贡",
        "adcode": "510300",
        "citycode": "0813"
    },
    {
        "name": "攀枝花",
        "adcode": "510400",
        "citycode": "0812"
    },
    {
        "name": "泸州",
        "adcode": "510500",
        "citycode": "0830"
    },
    {
        "name": "德阳",
        "adcode": "510600",
        "citycode": "0838"
    },
    {
        "name": "绵阳",
        "adcode": "510700",
        "citycode": "0816"
    },
    {
        "name": "广元",
        "adcode": "510800",
        "citycode": "0839"
    },
    {
        "name": "遂宁",
        "adcode": "510900",
        "citycode": "0825"
    },
    {
        "name": "内江",
        "adcode": "511000",
        "citycode": "1832"
    },
    {
        "name": "乐山",
        "adcode": "511100",
        "citycode": "0833"
    },
    {
        "name": "南充",
        "adcode": "511300",
        "citycode": "0817"
    },
    {
        "name": "眉山",
        "adcode": "511400",
        "citycode": "1833"
    },
    {
        "name": "宜宾",
        "adcode": "511500",
        "citycode": "0831"
    },
    {
        "name": "广安",
        "adcode": "511600",
        "citycode": "0826"
    },
    {
        "name": "达州",
        "adcode": "511700",
        "citycode": "0818"
    },
    {
        "name": "雅安",
        "adcode": "511800",
        "citycode": "0835"
    },
    {
        "name": "巴中",
        "adcode": "511900",
        "citycode": "0827"
    },
    {
        "name": "资阳",
        "adcode": "512000",
        "citycode": "0832"
    },
    {
        "name": "贵阳",
        "adcode": "520100",
        "citycode": "0851"
    },
    {
        "name": "六盘水",
        "adcode": "520200",
        "citycode": "0858"
    },
    {
        "name": "遵义",
        "adcode": "520300",
        "citycode": "0852"
    },
    {
        "name": "安顺",
        "adcode": "520400",
        "citycode": "0853"
    },
    {
        "name": "毕节",
        "adcode": "520500",
        "citycode": "0857"
    },
    {
        "name": "铜仁",
        "adcode": "520600",
        "citycode": "0856"
    },
    {
        "name": "昆明",
        "adcode": "530100",
        "citycode": "0871"
    },
    {
        "name": "曲靖",
        "adcode": "530300",
        "citycode": "0874"
    },
    {
        "name": "玉溪",
        "adcode": "530400",
        "citycode": "0877"
    },
    {
        "name": "保山",
        "adcode": "530500",
        "citycode": "0875"
    },
    {
        "name": "昭通",
        "adcode": "530600",
        "citycode": "0870"
    },
    {
        "name": "丽江",
        "adcode": "530700",
        "citycode": "0888"
    },
    {
        "name": "普洱",
        "adcode": "530800",
        "citycode": "0879"
    },
    {
        "name": "临沧",
        "adcode": "530900",
        "citycode": "0883"
    },
    {
        "name": "拉萨",
        "adcode": "540100",
        "citycode": "0891"
    },
    {
        "name": "日喀则",
        "adcode": "540200",
        "citycode": "0892"
    },
    {
        "name": "昌都",
        "adcode": "540300",
        "citycode": "0895"
    },
    {
        "name": "林芝",
        "adcode": "540400",
        "citycode": "0894"
    },
    {
        "name": "山南",
        "adcode": "540500",
        "citycode": "0893"
    },
    {
        "name": "那曲",
        "adcode": "540600",
        "citycode": "0896"
    },
    {
        "name": "西安",
        "adcode": "610100",
        "citycode": "029"
    },
    {
        "name": "铜川",
        "adcode": "610200",
        "citycode": "0919"
    },
    {
        "name": "宝鸡",
        "adcode": "610300",
        "citycode": "0917"
    },
    {
        "name": "咸阳",
        "adcode": "610400",
        "citycode": "0910"
    },
    {
        "name": "渭南",
        "adcode": "610500",
        "citycode": "0913"
    },
    {
        "name": "延安",
        "adcode": "610600",
        "citycode": "0911"
    },
    {
        "name": "汉中",
        "adcode": "610700",
        "citycode": "0916"
    },
    {
        "name": "榆林",
        "adcode": "610800",
        "citycode": "0912"
    },
    {
        "name": "安康",
        "adcode": "610900",
        "citycode": "0915"
    },
    {
        "name": "商洛",
        "adcode": "611000",
        "citycode": "0914"
    },
    {
        "name": "兰州",
        "adcode": "620100",
        "citycode": "0931"
    },
    {
        "name": "嘉峪关",
        "adcode": "620200",
        "citycode": "1937"
    },
    {
        "name": "金昌",
        "adcode": "620300",
        "citycode": "0935"
    },
    {
        "name": "白银",
        "adcode": "620400",
        "citycode": "0943"
    },
    {
        "name": "天水",
        "adcode": "620500",
        "citycode": "0938"
    },
    {
        "name": "武威",
        "adcode": "620600",
        "citycode": "1935"
    },
    {
        "name": "张掖",
        "adcode": "620700",
        "citycode": "0936"
    },
    {
        "name": "平凉",
        "adcode": "620800",
        "citycode": "0933"
    },
    {
        "name": "酒泉",
        "adcode": "620900",
        "citycode": "0937"
    },
    {
        "name": "庆阳",
        "adcode": "621000",
        "citycode": "0934"
    },
    {
        "name": "定西",
        "adcode": "621100",
        "citycode": "0932"
    },
    {
        "name": "陇南",
        "adcode": "621200",
        "citycode": "2935"
    },
    {
        "name": "西宁",
        "adcode": "630100",
        "citycode": "0971"
    },
    {
        "name": "海东",
        "adcode": "630200",
        "citycode": "0972"
    },
    {
        "name": "银川",
        "adcode": "640100",
        "citycode": "0951"
    },
    {
        "name": "石嘴山",
        "adcode": "640200",
        "citycode": "0952"
    },
    {
        "name": "固原",
        "adcode": "640400",
        "citycode": "0954"
    },
    {
        "name": "中卫",
        "adcode": "640500",
        "citycode": "1953"
    },
    {
        "name": "乌鲁木齐",
        "adcode": "650100",
        "citycode": "0991"
    },
]
export {data};
